import React from 'react';


import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { SwiperOptions, EffectCoverflow } from 'swiper';
import 'swiper/swiper.scss';
import 'swiper/components/effect-coverflow/effect-coverflow.scss';

interface IGalleryImage {
  name: string;
  url: string;
  alt: string;
}

interface IGalleryProps {
  images: IGalleryImage[];
  initialSlide?: number;
}

SwiperCore.use([EffectCoverflow]);

const Gallery = (props: IGalleryProps) => {
  console.log('gallery props', props);
  const { images, initialSlide } = props;

  const params: SwiperOptions = {
    effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    initialSlide: initialSlide,
    coverflowEffect: {
      rotate: 20,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows : false,
    },
  }

  return (
    <div className="row gallery">
      <div className="container">
        <div className="row">
          <Swiper
            {...params}
          >
            {images
              && Array.isArray(images)
              && images.length > 0
              && images.map((image: IGalleryImage, index: number) => {
                console.log('bg image', {backgroundImage: 'url(' + image.url + ')',})
                return (
                  <SwiperSlide
                    key={escape(image.name) + index}
                  >
                    <div
                      className="slide" 
                      style={{backgroundImage: 'url(' + image.url + ')',}}
                    />
                  </SwiperSlide>
                )
              })
            }
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Gallery;